module.exports = __webpack_public_path__ + "img/Calculateur@2x.066e8b28.png";